import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Label from 'components/Label';
import Icon from 'components/Icon';

import styles from './styles.module.scss';

const DetailEntityPreviewLabels = ({
	ageRestriction = null,
	tifloComments = null
}) =>
	(!!ageRestriction || ageRestriction === 0 || tifloComments) && (
		<div className={styles.labels}>
			{(!!ageRestriction || ageRestriction === 0) && (
				<Label
					className={cx(styles.label, styles.label_type_text)}
					content={`${ageRestriction}+`}
				/>
			)}
			{tifloComments && (
				<Label
					className={styles.label}
					content={<Icon icon="withTifloComments" className={styles.icon} />}
				/>
			)}
		</div>
	);

DetailEntityPreviewLabels.propTypes = {
	ageRestriction: PropTypes.number,
	tifloComments: PropTypes.bool
};

export default DetailEntityPreviewLabels;
